exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/**\n* DevExtreme (dx.common.css)\n* Version: 22.1.5\n* Build date: Fri Sep 02 2022\n*\n* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED\n* Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/\n*/\n/*!\nThis file is kept for backward compatibility.\nIt is no longer required.\n*/", ""]);

